(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-catering"] && !Shopify.designMode) return;
  try {
    
const cateringStatus = document.querySelector('#mc-catering-form [data-catering-status]');
if (cateringStatus) {
  cateringStatus.focus();
  cateringStatus.scrollIntoView({ block: 'center', behavior: 'auto' });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-finder"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mc-finder]').forEach(finder => {
  finder.querySelectorAll('[data-mc-choice]').forEach(button => {
    button.addEventListener('click', () => {
      const choice = button.dataset.mcChoice;
      finder.querySelectorAll('[data-mc-choice]').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
      finder.querySelectorAll('[data-mc-result]').forEach(result => { result.hidden = result.dataset.mcResult !== choice; });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
